import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
export var OpacityAnimation = function (props) {
    var animationClass = 'opacity';
    var showOrHide = props.show ? 'show' : 'hide';
    var classNames = namespacedClassnames(animationClass, showOrHide);
    return (React.createElement("div", { className: classNames }, props.children));
};
//# sourceMappingURL=opacity.js.map